import {useState,type FormEvent} from 'react';
import type {MerchantDispute,MerchantDisputeResponseInput} from '../src/merchant-dispute-types';
import {useHermes} from './lib/store';
import {useRequestIntent} from './lib/request-intent';

export function MerchantDisputeResponse({dispute}:{dispute:MerchantDispute}){
  const {state,actions}=useHermes(),[response,setResponse]=useState(''),[reason,setReason]=useState(''),intent=useRequestIntent();
  if(dispute.pastDue||!['needs_response','warning_needs_response'].includes(dispute.status))return null;
  const submit=(event:FormEvent<HTMLFormElement>)=>{
    event.preventDefault();
    const button=(event.nativeEvent as SubmitEvent).submitter;
    if(!(button instanceof HTMLButtonElement))return;
    const action=button.value as MerchantDisputeResponseInput['action'];
    const body={action,response:response.trim(),reason:reason.trim(),submissionCount:dispute.submissionCount};
    void actions.respondMerchantDispute(dispute.id,{...body,requestId:intent.id(body)}).then(()=>intent.clear()).catch(()=>undefined);
  };
  return <details><summary>Respond to dispute</summary><form onSubmit={submit}>
    <label className="field">Response<textarea rows={6} value={response} onChange={event=>setResponse(event.target.value)} required maxLength={150000}/></label>
    <label className="field">Reason for this action<input value={reason} onChange={event=>setReason(event.target.value)} required minLength={3} maxLength={1000}/></label>
    <p>Save a draft or send this response to the bank. Submission can incur a processor fee.</p>
    <button className="button" name="action" value="save" disabled={state.operation.label!==null}>Save draft</button>
    <button className="button" name="action" value="submit" disabled={state.operation.label!==null}>Submit to bank</button>
  </form></details>;
}
